const pad = (number, padding = 2) => (number <= 9999 ? `000${number}`.slice(-padding) : number)
export default pad
